module.exports = __webpack_public_path__ + "img/staticsSum.bc695927.png";